"use strict";
const { DATE } = require('../../../definitions/operandValueTypes');
exports.accepts = ({ valueType }) => valueType === DATE;
exports.parse = ({ value }) => Date.parse(new Date(value));
//# sourceMappingURL=dateParser.js.map